export const useWebpImage = () => {
  /**
   * Convert image URL to WebP format
   * @param {string} imageUrl - Original image URL
   * @param {boolean} forceWebp - Force conversion even if not png/jpg/jpeg
   * @returns {string} - WebP image URL
   */
  const toWebp = (imageUrl, forceWebp = true) => {
    if (!imageUrl) return ''

    // Check if the URL already has webp extension
    if (imageUrl.toLowerCase().endsWith('.webp')) {
      return imageUrl
    }

    // Replace common image extensions with webp
    const webpUrl = imageUrl.replace(/\.(png|jpe?g)$/i, '.webp')

    // If no replacement was made and forceWebp is true, append .webp
    if (webpUrl === imageUrl && forceWebp) {
      return `${imageUrl}.webp`
    }

    return webpUrl
  }

  /**
   * Check if browser supports WebP
   * @returns {boolean}
   */
  const supportsWebp = () => {
    if (process.server) return true // Assume support on server

    const elem = document.createElement('canvas')
    if (elem.getContext && elem.getContext('2d')) {
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
    }
    return false
  }

  /**
   * Get image URL with WebP fallback
   * @param {string} imageUrl - Original image URL
   * @param {boolean} checkSupport - Check browser support before conversion
   * @returns {string} - WebP or original image URL
   */
  const getImageUrl = (imageUrl, checkSupport = false) => {
    if (!imageUrl) return ''

    if (checkSupport && !supportsWebp()) {
      return imageUrl
    }

    return toWebp(imageUrl)
  }

  return {
    toWebp,
    supportsWebp,
    getImageUrl
  }
}
